import { useTranslation } from "@opendash/core";
import { _User } from "@opendash/plugin-parse/dist/types-generated";
import { Button, Drawer, Form, Input, InputNumber, Space } from "antd";
import Parse from "parse";
import React, { useContext, useState } from "react";
import { AgencyContext } from "../contexts/AgencyContext";
import { Level } from "../js/parsegenerated";

export const LevelCreateDrawer = (props: { open: boolean; onOk: Function }) => {
  const t = useTranslation();
  const [form] = Form.useForm<{
    level_index: number;
    level_name: string;
  }>();
  const state = useContext(AgencyContext);
  const [loading, setLoading] = useState<boolean>(false);

  const close = () => {
    props.onOk();
  };

  const save = () => {
    setLoading(true);
    form.validateFields().then(
      async (values) => {
        const level = new Level();
        level.set("level_index", values.level_index);
        level.set("level_name", values.level_name);
        level.set("tenant", (Parse.User.current() as _User).get("tenant"));
        await level.save();

        props.onOk();
        form.resetFields();
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  };

  return (
    <>
      <Drawer
        title={t("gtfs:level.create.headline")}
        placement={"bottom"}
        height={"80%"}
        onClose={() => close()}
        open={props.open}
        extra={
          <Space>
            <Button onClick={() => close()}>
              {t("gtfs:global.button.close_label")}
            </Button>
            <Button onClick={() => save()} loading={loading} type="primary">
              {t("gtfs:global.button.save_label")}
            </Button>
          </Space>
        }
      >
        <Form form={form} layout="vertical" autoComplete="off">
          <Form.Item
            label="Index"
            name="level_index"
            rules={[
              {
                required: true,
                message: t(
                  "gtfs:level.create.form.level_index.rules.required.message"
                ),
              },
            ]}
          >
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label="Name"
            name="level_name"
            rules={[
              {
                required: true,
                message: t(
                  "gtfs:level.create.form.level_name.rules.required.message"
                ),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};
